import React, { ReactNode, useEffect } from 'react'

import { ButtonSizeValue } from '@mc/design-system'
import { useTrackExperimentViewedFE } from '@mc/experiments-react'

import { MasterClassWordmark } from './MasterClassWordmark'
import { usePurchaseCtaCopyExperiment } from '../hooks'
import { PURCHASE_CTA_COPY_EXP_NAME } from '../utils'

interface EnhancedCtaCopyProps {
  children: ReactNode
  size?: ButtonSizeValue
}

export const EnhancedCtaCopy = ({
  children,
  size = 'md',
}: EnhancedCtaCopyProps) => {
  const { enhanceableCopies, trackPurchaseCtaExperiment } =
    usePurchaseCtaCopyExperiment()

  useTrackExperimentViewedFE(PURCHASE_CTA_COPY_EXP_NAME)

  useEffect(() => {
    trackPurchaseCtaExperiment()
  }, [trackPurchaseCtaExperiment])

  if (typeof children === 'string' && enhanceableCopies.includes(children)) {
    const parts = children.split('MasterClass')
    const iconHeight = ['xs', 'sm'].includes(size) ? 10 : 12

    return (
      <span aria-label={children}>
        {parts.map((part, index) => (
          <span key={index} className='d-inline-flex align-items-baseline'>
            {part}
            {index < parts.length - 1 && (
              <MasterClassWordmark height={iconHeight} className='mc-mx-1' />
            )}
          </span>
        ))}
      </span>
    )
  }

  return children
}
